import React, { useMemo } from 'react';
import { Observer } from 'mobx-react';
import {
  Card,
  Grid,
  CardHeader,
  CardContent,
  Divider,
} from '@material-ui/core';
import { Bar } from 'react-chartjs-2';
import { COLORS } from '../../util/Colors';
import { safeFalsy } from '../../util/UtilFunctions';

const IncomeByMonth = ({ data, showNet }) => {
  if (!data) return null;

  const monthLabels = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const colorList = [COLORS.midnight, COLORS.red, COLORS.blue];

  const formattedDataset = useMemo(() => {
    const dataset = data.reduce(
      (buckets, { Year, GrossAmount, NetAmount, Month }) => {
        if (!buckets[Year]) {
          buckets[Year] = {};
          buckets[Year].data = [];
          buckets[Year].label = Year;
          buckets[Year].backgroundColor = colorList.pop();
        }
        buckets[Year].data[Month - 1] = showNet
          ? safeFalsy(NetAmount, '0.00')
          : safeFalsy(GrossAmount, '0.00');
        return buckets;
      },
      {},
    );
    return {
      labels: monthLabels,
      datasets: Object.values(dataset),
    };
  }, [data, showNet]);

  return (
    <Observer
      render={() => {
        return (
          <Grid item lg={12} xs={12}>
            <Card style={{ height: '100%' }}>
              <CardHeader
                title={`${showNet ? 'Net' : 'Gross'} Deal Income by Month`}
              />
              <Divider />
              <CardContent>
                <Bar
                  data={formattedDataset}
                  height={100}
                  options={{
                    scales: {
                      yAxes: [
                        {
                          ticks: {
                            // Include a dollar sign in the ticks
                            callback(value) {
                              return `$${value
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
                            },
                          },
                        },
                      ],
                    },

                    legend: {
                      position: 'bottom',
                    },
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        );
      }}
    />
  );
};

export default IncomeByMonth;
